/** Parent context color resolution for nested task rows. */
import { useMemo } from 'react';
import { normalizeTaskTags } from '@/features/tasks/utils/data/taskTags';
import { getContextColor } from '@/features/tasks/utils/ui/colorUtils';
import { computeDisplayLevel } from '@/features/tasks/utils/ui/taskListItemUtils';

export function useParentContextColor({
  displayLevel,
  index,
  tasks,
  indentationType,
  isExecutionView,
}) {
  return useMemo(() => {
    if (displayLevel === 0) return 'transparent';
    if (!tasks || tasks.length === 0) return 'var(--color-grey-300)';
    for (let i = index - 1; i >= 0; i--) {
      const t = tasks[i];
      const l = computeDisplayLevel(t, indentationType, isExecutionView, []);
      if (l < displayLevel) {
        const { allContexts: pContexts } = normalizeTaskTags(t);
        return pContexts.length > 0
          ? getContextColor(pContexts[0])
          : 'var(--color-grey-300)';
      }
    }
    return 'var(--color-grey-300)';
  }, [displayLevel, index, tasks, indentationType, isExecutionView]);
}
